<template>
  <div id="baseFormATCommand" class="content-fade-in">
    <CRow class="pb-2">
      <CCol sm="12" md="12" xl="12" xs="12">
        <div class="chat-container custom-scroll">
          <!--          <i class="fa fa-spinner fa-spin" v-show="loading.value"-->
          <!--             style="font-size: 50px;color:rgba(128,128,128,0.74);position: absolute;top: 50px; left: 45%;"></i>-->
          <ul class="chat-list content-notification">
            <template v-for="each in items">
              <li v-if="each.cmd" class="chat-item chat-item-sender"
                  v-c-tooltip="$helper.formatDate(each.createDate)">
                <span>{{ each.cmd }}</span>
              </li>
              <li v-if="each.data" class="chat-item chat-item-receiver"
                  v-c-tooltip="$helper.formatDate(each.updateDate)">
                <span>{{ each.data }}</span>
              </li>
            </template>
          </ul>
          <span v-if="items.length <= 0"
                style="text-align: center;position: absolute;top: 45%;right: 45%;color: rgba(128,128,128,0.53)">Hộp thư trống...</span>
          <div class="chat-form pt-4">
            <input type="text" placeholder="Type a message..." class="chat-input" v-model="contentCmd"
                   @keyup.enter="submitSendATCmd()" ref="inputCmd" @keypress.ctrl="keyPressInput"/>
            <CButton class="btn btn-primary chat-send" @click.prevent="submitSendATCmd()"><i
              class="fa fa-send"></i> Gửi
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2";
import BaseSwitch from "../base/BaseSwitch";
import BaseTextArea from "../base/BaseTextArea";
import BaseFormLoading from "../base/BaseFormLoading";
import RangeSlider from 'vue-range-slider'
import {DatePicker} from "v-calendar";
import BaseModal from "@/views/base/BaseModal";

export default {
  name: "BaseFormATCommand",
  components: {
    BaseModal,
    BaseTable,
    BaseInput,
    BaseSelect,
    BaseSwitch,
    ModalConfirm,
    BaseTextArea,
    BaseFormLoading,
    RangeSlider,
    DatePicker
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  props: {
    phoneNumber: String,
  },
  data() {
    return {
      loading: {value: false},
      contentCmd: '',
      pageSize: 10,
      pageNumber: 0,
      totalElement: 0,
      totalPages: 0,
      items: []
    }
  },
  methods: {
    loadShowMoreData() {
      let that = this;
      const chatWindow = document.querySelector('.chat-list');
      const loadMoreThreshold = 200;
      chatWindow.addEventListener('scroll', function () {
        if (!that.loading.value && chatWindow.scrollTop <= loadMoreThreshold) {
          // load thêm dữ liệu ở đây
          if (that.pageNumber < that.totalPages) {
            that.loading.value = true;
            that.loadMessageATCmd();
          }
        }
      });
    },
    keyPressInput(e) {
      if (e.keyCode == 26) {
        this.submitSendATCmd();
      }
    },
    submitSendATCmd() {
      let isValid = true;
      if (this.contentCmd === '' || this.contentCmd === null) {
        isValid = false;
      }
      if (!isValid) {
        return;
      }
      let that = this;
      this.$helper.loadDataSource({
        url: "/at-cmd/sendATCmd",
        dataSubmit() {
          return {
            phoneNumber: that.phoneNumber,
            cmd: encodeURIComponent(that.contentCmd),
          }
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.contentCmd = '';
            that.items.push({cmd: response.data.data.cmd, createDate: response.data.data.createDate})
            that.scrollToBottomChat();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    loadMessageATCmd() {
      let that = this;
      this.$helper.loadDataSource({
        url: "/at-cmd/getPages",
        dataSubmit() {
          return {
            pageSize: that.pageSize,
            pageNumber: that.pageNumber,
            phoneNumber: that.phoneNumber,
          }
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.totalElement = response.data.data.totalElement;
            response.data.data.dataContent.content.map(each => that.items.unshift(each));
            that.pageNumber += 1;
            that.totalPages = Math.ceil(that.totalElement / that.pageSize);
            that.loading.value = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    scrollToBottomChat() {
      setTimeout(() => {
        const chatWindow = document.querySelector('.chat-list');
        chatWindow.scrollTop = chatWindow.scrollHeight - chatWindow.clientHeight;
      }, 100)
    }
  },
  created: function () {
  },
  mounted() {
    this.$refs.inputCmd.focus();
    this.loadShowMoreData();
    this.loadMessageATCmd();
    this.scrollToBottomChat();
  },
  watch: {
    '$store.state.atCmd': function (value) {
      this.items.push({data: value.data.data, updateDate: value.data.updateDate})
      this.scrollToBottomChat();
    }
  },
  computed: {}
};
</script>
<style scoped>
/* Style for chat container */
.chat-container {
  display: flex;
  flex-direction: column;
  height: 80vh;
  background-color: #f2f2f2;
}

/* Style for chat message list */
.chat-list {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
  padding: 10px;
}

.chat-list li {
  list-style: none;
}

/* Style for chat message item */
.chat-item {
  max-width: 60%;
  min-width: 20%;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
}

/* Style for chat message item: sender */
.chat-item-sender {
  background-color: #fff;
  align-self: flex-end;
}

/* Style for chat message item: receiver */
.chat-item-receiver {
  background-color: #dcf8c6;
  align-self: flex-start;
}

/* Style for chat input form */
.chat-form {
  display: flex;
  align-items: center;
  padding: 5px;
  background-color: #fff;
  width: 100%;
}

/* Style for chat input field */
.chat-input {
  flex-grow: 1;
  padding: 7px 15px 7px 15px;
  border-radius: 30px;
  border: none;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  font-size: 16px;
  border: 1px solid rgba(128, 128, 128, 0.34);
}

/* Style for chat send button */
.chat-send {
  /*background-color: #0084ff;*/
  color: #fff;
  border: none;
  /*border-radius: 50%;*/
  /*padding: 10px;*/
  font-size: 16px;
  cursor: pointer;
}
</style>
